import React from 'react';
import { Switch, Route } from 'react-router-dom'; // withRouter

import { PartialRepayment } from './PartialRepayment/index';
import { GuaranteedInheritance } from './GuaranteedInheritance/index';
import { LtvCalculator } from './LtvCalculator/index';
import { Calculators } from './Calculators/index';
import { rootClass } from './../config/mount';
import './App.css';

const App = () => (
  <div className={rootClass()}>
    <Switch>
      {/*<Route exact path='/partial-repayment' component={PartialRepayment} />*/}
      {/*<Route exact path='/ltv-calculator' component={LtvCalculator} />*/}
      {/*<Route exact path='/ltv-calculator:Id' component={LtvCalculator} />*/}
      {/*<Route exact path='/guaranteed-inheritance' component={GuaranteedInheritance} />*/}
      {/*<Route exact path='/' component={Calculators} />*/}
      <Route exact path='/' component={PartialRepayment} />
    </Switch>
  </div>
);

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js